/* ============================================================
   Crash Exchange claim and product registration.
   Generated by scripts/build_theme_claimform.py. Do not edit here.

   Files go straight from the browser to Supabase Storage using a
   short-lived signed URL, so a phone photo never has to fit inside
   a serverless request body. The claim itself is posted afterwards
   carrying only the storage paths.
   ============================================================ */
(function () {
  'use strict';

  var form = document.querySelector('[data-claim]');
  if (!form) return;

  var API = form.getAttribute('data-endpoint');
  var KIND = form.getAttribute('data-claim') || 'crash';
  var msgBox = form.querySelector('[data-claim-msg]');
  var uploads = [];   // {path, name, type, bytes, kind}

  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var kb = function (n) {
    return n > 1048576 ? (n / 1048576).toFixed(1) + ' MB' : Math.max(1, Math.round(n / 1024)) + ' KB';
  };

  function say(kind, text) {
    msgBox.innerHTML = '<div class="fmsg is-' + kind + '">'
      + '<svg class="ico" aria-hidden="true"><use href="#' + (kind === 'bad' ? 'i-info' : 'i-verified') + '"></use></svg>'
      + '<span>' + esc(text) + '</span></div>';
    msgBox.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }
  function clearSay() { msgBox.innerHTML = ''; }

  /* ---------- the 30 day rule ----------
     Liquid rendered these once and Shopify caches the page, so by the time a
     customer sees it the bounds could be a day stale. Recomputed here, which
     is also where the friendlier message lives. The server checks it again;
     a deadline that only exists in the browser is not a deadline. */
  var acc = form.querySelector('[name=accidentDate]');
  if (acc) {
    var d = new Date();
    var iso = function (t) { return new Date(t).toISOString().slice(0, 10); };
    acc.max = iso(d);
    acc.min = iso(d.getTime() - 30 * 86400000);
    acc.addEventListener('change', function () {
      if (!acc.value) return;
      var age = Math.floor((Date.now() - new Date(acc.value + 'T00:00:00').getTime()) / 86400000);
      if (age > 30) {
        say('bad', 'That is ' + age + ' days ago, and a Crash Exchange claim has to be lodged within 30 days. Please contact support so we can look at it with you.');
      } else if (age < 0) {
        say('bad', 'That date is in the future.');
      } else {
        clearSay();
      }
    });
  }
  var pd = form.querySelector('[name=purchaseDate]');
  if (pd) pd.max = new Date().toISOString().slice(0, 10);

  /* ---------- uploads ---------- */
  [].forEach.call(form.querySelectorAll('[data-drop]'), function (zone) {
    var input = zone.querySelector('.drop-input');
    var list = zone.querySelector('[data-drop-list]');
    var kind = zone.getAttribute('data-drop');
    var max = parseInt(zone.getAttribute('data-max'), 10) || 1;

    var render = function () {
      var mine = uploads.filter(function (u) { return u.kind === kind; });
      list.innerHTML = mine.map(function (u) {
        return '<li' + (u.failed ? ' class="is-bad"' : (u.pending ? ' class="is-busy"' : '')) + '>'
          + '<span class="n">' + esc(u.name) + '</span>'
          + '<span class="s">' + (u.pending ? 'Uploading…' : (u.failed ? 'Failed' : kb(u.bytes))) + '</span>'
          + (u.pending ? '' : '<button type="button" class="x" data-remove="' + esc(u.uid) + '" aria-label="Remove ' + esc(u.name) + '">&times;</button>')
          + '</li>';
      }).join('');
      zone.classList.toggle('has-files', mine.length > 0);
    };

    var accept = function (files) {
      var mine = uploads.filter(function (u) { return u.kind === kind; });
      var room = max - mine.length;
      if (room <= 0) { say('bad', max === 1 ? 'Remove the current file first.' : 'That is the most files we can take here.'); return; }
      [].slice.call(files, 0, room).forEach(send);
    };

    var send = function (file) {
      var rec = {
        uid: String(Date.now()) + Math.random().toString(36).slice(2, 7),
        name: file.name, type: file.type || 'application/octet-stream',
        bytes: file.size, kind: kind, pending: true
      };
      uploads.push(rec);
      render();

      fetch(API + '/upload-url', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ fileName: file.name, contentType: rec.type, bytes: file.size })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (!res || !res.ok) throw new Error(res && res.error || 'Upload could not start');
          // The signed URL is a PUT straight at Supabase Storage. Nothing about
          // this file passes through our own compute.
          return fetch(res.signedUrl, {
            method: 'PUT',
            headers: { 'Content-Type': rec.type, 'x-upsert': 'false' },
            body: file
          }).then(function (up) {
            if (!up.ok) throw new Error('Upload failed');
            rec.path = res.path;
            rec.pending = false;
            render();
            clearSay();
          });
        })
        .catch(function (err) {
          rec.pending = false; rec.failed = true; render();
          say('bad', err.message || 'That file would not upload. Try a smaller photo.');
        });
    };

    input.addEventListener('change', function () { accept(input.files); input.value = ''; });

    ['dragenter', 'dragover'].forEach(function (ev) {
      zone.addEventListener(ev, function (e) { e.preventDefault(); zone.classList.add('is-over'); });
    });
    ['dragleave', 'drop'].forEach(function (ev) {
      zone.addEventListener(ev, function (e) { e.preventDefault(); zone.classList.remove('is-over'); });
    });
    zone.addEventListener('drop', function (e) {
      if (e.dataTransfer && e.dataTransfer.files) accept(e.dataTransfer.files);
    });

    list.addEventListener('click', function (e) {
      var b = e.target.closest('[data-remove]');
      if (!b) return;
      var uid = b.getAttribute('data-remove');
      uploads = uploads.filter(function (u) { return u.uid !== uid; });
      render();
    });
  });

  /* ---------- submit ---------- */
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    clearSay();

    // The browser's own validity check, but reported in one place at the top
    // rather than as a native bubble on whichever field happens to be first.
    var bad = null;
    [].forEach.call(form.elements, function (f) {
      if (!bad && f.name && f.willValidate && !f.checkValidity()) bad = f;
    });
    if (bad) {
      var label = form.querySelector('label[for="' + bad.id + '"]');
      say('bad', (label ? label.textContent.replace('*', '').trim() : 'A field') + ' needs filling in.');
      bad.focus();
      return;
    }

    if (uploads.some(function (u) { return u.pending; })) {
      say('bad', 'Give the uploads a moment to finish.');
      return;
    }
    var ready = uploads.filter(function (u) { return u.path; });
    if (KIND === 'crash' && !ready.some(function (u) { return u.kind === 'receipt'; })) {
      say('bad', 'Proof of purchase is required. Add a photo of your receipt.');
      return;
    }
    if (KIND === 'crash' && !ready.some(function (u) { return u.kind === 'photo'; })) {
      say('bad', 'At least one photograph of the product is required.');
      return;
    }

    var data = { kind: KIND, files: ready.map(function (u) {
      return { path: u.path, name: u.name, type: u.type, bytes: u.bytes, kind: u.kind };
    }) };
    [].forEach.call(form.elements, function (f) {
      if (f.name) data[f.name] = (f.value || '').trim();
    });

    var btn = form.querySelector('button[type=submit]');
    var label2 = btn.textContent;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Sending…';

    fetch(API, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) })
      .then(function (r) { return r.json(); })
      .catch(function () { return { ok: false, error: 'We could not reach the server. Check your connection and try again.' }; })
      .then(function (res) {
        btn.removeAttribute('aria-busy');
        btn.textContent = label2;
        if (!res || !res.ok) { say('bad', (res && res.error) || 'That did not send.'); return; }
        done(res.reference);
      });
  });

  /* The form is replaced rather than reset. Somebody who has just described a
     car accident should not be looking at the empty fields again wondering
     whether it went. */
  function done(ref) {
    var claim = KIND === 'crash';
    form.innerHTML = '<div class="claim-done">'
      + '<svg class="ico" aria-hidden="true"><use href="#i-verified"></use></svg>'
      + '<h3>' + (claim ? 'Your claim is with us' : 'Your product is registered') + '</h3>'
      + '<p>We have emailed a copy to you. Quote this reference if you need to get in touch about it.</p>'
      + '<div class="claim-ref"><span>Reference</span><b>' + esc(ref) + '</b></div>'
      + (claim ? '<p class="fine">We check the details against the Crash Exchange terms and come back to you. If anything is missing we will ask rather than close it.</p>' : '')
      + '</div>';
    form.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }
})();
